/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DamageDto } from './DamageDto';
import {
	DamageDtoFromJSON,
	DamageDtoFromJSONTyped,
	DamageDtoToJSON,
	DamageDtoToJSONTyped,
} from './DamageDto';
import type { VehicleDto } from './VehicleDto';
import {
	VehicleDtoFromJSON,
	VehicleDtoFromJSONTyped,
	VehicleDtoToJSON,
	VehicleDtoToJSONTyped,
} from './VehicleDto';
import type { EasyClaimAppState } from './EasyClaimAppState';
import {
	EasyClaimAppStateFromJSON,
	EasyClaimAppStateFromJSONTyped,
	EasyClaimAppStateToJSON,
	EasyClaimAppStateToJSONTyped,
} from './EasyClaimAppState';
import type { EasyClaimCustomerConfigurationDto } from './EasyClaimCustomerConfigurationDto';
import {
	EasyClaimCustomerConfigurationDtoFromJSON,
	EasyClaimCustomerConfigurationDtoFromJSONTyped,
	EasyClaimCustomerConfigurationDtoToJSON,
	EasyClaimCustomerConfigurationDtoToJSONTyped,
} from './EasyClaimCustomerConfigurationDto';
import type { EasyClaimCaseState } from './EasyClaimCaseState';
import {
	EasyClaimCaseStateFromJSON,
	EasyClaimCaseStateFromJSONTyped,
	EasyClaimCaseStateToJSON,
	EasyClaimCaseStateToJSONTyped,
} from './EasyClaimCaseState';
import type { EasyClaimDocumentDto } from './EasyClaimDocumentDto';
import {
	EasyClaimDocumentDtoFromJSON,
	EasyClaimDocumentDtoFromJSONTyped,
	EasyClaimDocumentDtoToJSON,
	EasyClaimDocumentDtoToJSONTyped,
} from './EasyClaimDocumentDto';
import type { LocalizedCaseUrl } from './LocalizedCaseUrl';
import {
	LocalizedCaseUrlFromJSON,
	LocalizedCaseUrlFromJSONTyped,
	LocalizedCaseUrlToJSON,
	LocalizedCaseUrlToJSONTyped,
} from './LocalizedCaseUrl';

/**
 *
 * @export
 * @interface EasyClaimCaseResponseDto
 */
export interface EasyClaimCaseResponseDto {
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCaseResponseDto
	 */
	damageNumber?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCaseResponseDto
	 */
	caseId?: string;
	/**
	 *
	 * @type {EasyClaimCaseState}
	 * @memberof EasyClaimCaseResponseDto
	 */
	caseState?: EasyClaimCaseState;
	/**
	 *
	 * @type {EasyClaimAppState}
	 * @memberof EasyClaimCaseResponseDto
	 */
	state?: EasyClaimAppState;
	/**
	 *
	 * @type {EasyClaimCustomerConfigurationDto}
	 * @memberof EasyClaimCaseResponseDto
	 */
	_configuration?: EasyClaimCustomerConfigurationDto;
	/**
	 *
	 * @type {VehicleDto}
	 * @memberof EasyClaimCaseResponseDto
	 */
	vehicle?: VehicleDto;
	/**
	 *
	 * @type {DamageDto}
	 * @memberof EasyClaimCaseResponseDto
	 */
	damage?: DamageDto;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCaseResponseDto
	 */
	tin?: string | null;
	/**
	 *
	 * @type {Array<EasyClaimDocumentDto>}
	 * @memberof EasyClaimCaseResponseDto
	 */
	documents?: Array<EasyClaimDocumentDto> | null;
	/**
	 *
	 * @type {number}
	 * @memberof EasyClaimCaseResponseDto
	 */
	feedbackRating?: number | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCaseResponseDto
	 */
	feedbackComment?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCaseResponseDto
	 */
	bankAccountOwnerName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCaseResponseDto
	 */
	bankAccountNumber?: string | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCaseResponseDto
	 */
	isTest?: boolean | null;
	/**
	 *
	 * @type {Array<LocalizedCaseUrl>}
	 * @memberof EasyClaimCaseResponseDto
	 */
	localizedCaseUrls?: Array<LocalizedCaseUrl> | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCaseResponseDto
	 */
	offerFeedbackComment?: string | null;
	/**
	 *
	 * @type {number}
	 * @memberof EasyClaimCaseResponseDto
	 */
	offerFeedbackRating?: number | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCaseResponseDto
	 */
	finishUploadRedirectLink?: string | null;
	/**
	 *
	 * @type {Date}
	 * @memberof EasyClaimCaseResponseDto
	 */
	expectedTimeoutDate?: Date | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCaseResponseDto
	 */
	specialTranslation?: string | null;
}

/**
 * Check if a given object implements the EasyClaimCaseResponseDto interface.
 */
export function instanceOfEasyClaimCaseResponseDto(
	value: object
): value is EasyClaimCaseResponseDto {
	return true;
}

export function EasyClaimCaseResponseDtoFromJSON(json: any): EasyClaimCaseResponseDto {
	return EasyClaimCaseResponseDtoFromJSONTyped(json, false);
}

export function EasyClaimCaseResponseDtoFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimCaseResponseDto {
	if (json == null) {
		return json;
	}
	return {
		damageNumber: json['damageNumber'] == null ? undefined : json['damageNumber'],
		caseId: json['caseId'] == null ? undefined : json['caseId'],
		caseState:
			json['caseState'] == null ? undefined : EasyClaimCaseStateFromJSON(json['caseState']),
		state: json['state'] == null ? undefined : EasyClaimAppStateFromJSON(json['state']),
		_configuration:
			json['configuration'] == null
				? undefined
				: EasyClaimCustomerConfigurationDtoFromJSON(json['configuration']),
		vehicle: json['vehicle'] == null ? undefined : VehicleDtoFromJSON(json['vehicle']),
		damage: json['damage'] == null ? undefined : DamageDtoFromJSON(json['damage']),
		tin: json['tin'] == null ? undefined : json['tin'],
		documents:
			json['documents'] == null
				? undefined
				: (json['documents'] as Array<any>).map(EasyClaimDocumentDtoFromJSON),
		feedbackRating: json['feedbackRating'] == null ? undefined : json['feedbackRating'],
		feedbackComment: json['feedbackComment'] == null ? undefined : json['feedbackComment'],
		bankAccountOwnerName:
			json['bankAccountOwnerName'] == null ? undefined : json['bankAccountOwnerName'],
		bankAccountNumber: json['bankAccountNumber'] == null ? undefined : json['bankAccountNumber'],
		isTest: json['isTest'] == null ? undefined : json['isTest'],
		localizedCaseUrls:
			json['localizedCaseUrls'] == null
				? undefined
				: (json['localizedCaseUrls'] as Array<any>).map(LocalizedCaseUrlFromJSON),
		offerFeedbackComment:
			json['offerFeedbackComment'] == null ? undefined : json['offerFeedbackComment'],
		offerFeedbackRating:
			json['offerFeedbackRating'] == null ? undefined : json['offerFeedbackRating'],
		finishUploadRedirectLink:
			json['finishUploadRedirectLink'] == null ? undefined : json['finishUploadRedirectLink'],
		expectedTimeoutDate:
			json['expectedTimeoutDate'] == null ? undefined : new Date(json['expectedTimeoutDate']),
		specialTranslation: json['specialTranslation'] == null ? undefined : json['specialTranslation'],
	};
}

export function EasyClaimCaseResponseDtoToJSON(json: any): EasyClaimCaseResponseDto {
	return EasyClaimCaseResponseDtoToJSONTyped(json, false);
}

export function EasyClaimCaseResponseDtoToJSONTyped(
	value?: EasyClaimCaseResponseDto | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		damageNumber: value['damageNumber'],
		caseId: value['caseId'],
		caseState: EasyClaimCaseStateToJSON(value['caseState']),
		state: EasyClaimAppStateToJSON(value['state']),
		configuration: EasyClaimCustomerConfigurationDtoToJSON(value['_configuration']),
		vehicle: VehicleDtoToJSON(value['vehicle']),
		damage: DamageDtoToJSON(value['damage']),
		tin: value['tin'],
		documents:
			value['documents'] == null
				? undefined
				: (value['documents'] as Array<any>).map(EasyClaimDocumentDtoToJSON),
		feedbackRating: value['feedbackRating'],
		feedbackComment: value['feedbackComment'],
		bankAccountOwnerName: value['bankAccountOwnerName'],
		bankAccountNumber: value['bankAccountNumber'],
		isTest: value['isTest'],
		localizedCaseUrls:
			value['localizedCaseUrls'] == null
				? undefined
				: (value['localizedCaseUrls'] as Array<any>).map(LocalizedCaseUrlToJSON),
		offerFeedbackComment: value['offerFeedbackComment'],
		offerFeedbackRating: value['offerFeedbackRating'],
		finishUploadRedirectLink: value['finishUploadRedirectLink'],
		expectedTimeoutDate:
			value['expectedTimeoutDate'] == null
				? value['expectedTimeoutDate']
				: value['expectedTimeoutDate'].toISOString(),
		specialTranslation: value['specialTranslation'],
	};
}
